<!-- Modal -->
<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog" role="document" >
    <div class="modal-content" style="width: 550px;margin-left: 5%;    border-radius: 7px;">
      <div class="modal-header" style="line-height: 0.5;border-bottom: 1px solid #E74C3C;background: #E74C3C;border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <div class="modal-title" id="exampleModalLongTitle" style="color: white;font-size: 20px;font-variant-caps: all-small-caps;font-weight: 500">
          <i class="fas fa-exclamation-triangle" style="font-size: 33px;"></i>
          <span>&nbsp;&nbsp;{{title}}</span>
        </div>
        <div style="color: white;font-size: 10px;padding-left: 45px;">Warning on {{ brand.name }} service suspension and invoice payment...</div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="visible = 'none'" style="margin-top: -50px;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [innerHTML]="body_content">
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger btn-lg btn-block" (click)="popupOkAction()">{{button_text}}</button>
      </div>
    </div>
  </div>
</div>
